import { useMutation } from '@tanstack/react-query';

import { $apiV2, errorHandler } from 'modules/global';

export function useSaveCourse() {
  return useMutation({
    mutationFn: async ({ teacherCourseId, action }: { teacherCourseId?: number; action: 'add' | 'remove' }) => {
      const { data } = await $apiV2.post(`/teacher-course/save-course`, { teacher_course_id: teacherCourseId, action });

      return data;
    },
    onError: errorHandler()
  });
}
